import { createContext, useContext } from 'react';
import { FilterContextType } from './types';

const FilterContext = createContext<FilterContextType>({
  isExpanded: false,
  setIsExpanded: () => {},
});

export const FilterProvider = FilterContext.Provider;

export const useExpand = () => useContext(FilterContext);
